import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onMounted, onUnmounted, watch, createApp } from "vue";
import mapboxgl, { LngLatLike } from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import { Translations } from "~/js/interfaces/translations";
import Marker from "~/vue/atoms/markers/Marker.vue";

interface Props {
	location: {
		longitude: number;
		latitude: number;
		type: string;
		availableNow: boolean;
	} | null;
	translations?: Translations | null;
	utilities?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MapLocation',
  props: {
    location: {},
    translations: {},
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const mapContainer = ref<HTMLElement | null>(null);
let map: mapboxgl.Map | null = null;
let marker: mapboxgl.Marker | null = null;

const mapboxApi = computed(() => import.meta.env.VITE_MAPBOX_API ?? "");
const centerLngLat = computed((): LngLatLike => [props.location?.longitude ?? 0, props.location?.latitude ?? 0]);

const addMarker = () => {
	if (!map || !props.location) return;

	// Remove old marker if it exists
	if (marker) {
		marker.remove();
	}

	const el = document.createElement("div");
	createApp(Marker, {
		type: props.location.type,
		status: props.location.availableNow ? "available" : "soon",
	}).mount(el);

	marker = new mapboxgl.Marker({
		element: el,
		anchor: "bottom",
		offset: [0, -8],
	})
		.setLngLat(centerLngLat.value)
		.addTo(map);
};

onMounted(() => {
	if (!mapContainer.value) return;

	mapboxgl.accessToken = mapboxApi.value;
	map = new mapboxgl.Map({
		container: mapContainer.value,
		style: "mapbox://styles/mapbox/light-v11",
		center: centerLngLat.value,
		zoom: 5,
	});

	map.on("load", () => {
		addMarker();
	});
});

watch(
	() => props.location,
	() => {
		if (map && props.location) {
			map.setCenter(centerLngLat.value);
			addMarker();
		}
	},
	{ deep: true },
);

onUnmounted(() => {
	if (map) {
		map.remove();
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["aspect-[11/13] overflow-hidden rounded-3xl", __props.utilities])
  }, [
    _createElementVNode("div", {
      ref_key: "mapContainer",
      ref: mapContainer,
      class: "h-full w-full grow"
    }, null, 512)
  ], 2))
}
}

})